import { render, staticRenderFns } from "./orderBar.vue?vue&type=template&id=2eaafc63&scoped=true&"
import script from "./orderBar.vue?vue&type=script&lang=js&"
export * from "./orderBar.vue?vue&type=script&lang=js&"
import style0 from "./orderBar.vue?vue&type=style&index=0&id=2eaafc63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaafc63",
  null
  
)

export default component.exports